import React from 'react'
// import { useI18next } from 'gatsby-plugin-react-i18next'
import { useStore, authStoreId } from 'stores'

const Application = ({children}) => {
  const authStore = useStore(authStoreId)
  // const { ready } = useI18next()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    // First Load code
    // BUG: Need hook to know i18next initialied
    if (authStore.getters.isLoggedIn()) {
      authStore.actions.handleInitApp()
    }
  }, [])

  return (
    <>
      {children}
    </>
  )
}
export default Application